module.exports = __webpack_public_path__ + "img/bird-12-right.1e44b217.png";